var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0006 6.33301C20.489 6.33301 6.33398 20.488 6.33398 37.9997C6.33398 55.5113 20.489 69.6663 38.0006 69.6663C55.5123 69.6663 69.6673 55.5113 69.6673 37.9997C69.6673 20.488 55.5123 6.33301 38.0006 6.33301ZM53.834 49.368L49.369 53.833L38.0006 42.4647L26.6323 53.833L22.1673 49.368L33.5357 37.9997L22.1673 26.6313L26.6323 22.1663L38.0006 33.5347L49.369 22.1663L53.834 26.6313L42.4656 37.9997L53.834 49.368Z",
    fill: "#F92F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.06610ecc98e289c057115133fffc5327.svg";
export { ForwardRef as ReactComponent };